import { __assign } from "tslib";
import * as React from 'react';
function IconArrowLeftSizeM(props) {
    return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M4 12.5L11.2412 20L12.2441 18.9609L6.77832 13.2998H20V11.8311H6.65137L12.2441 6.03809L11.2412 5L4 12.5Z" })));
}
export default IconArrowLeftSizeM;
